var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/contacts"}},[_vm._v("Contacts")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/test"}},[_vm._v("Test")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }